/** @jsxImportSource @emotion/react */

import React from 'react';
import Configuration from '@component/iyagigo/studio/configuration';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useLocation, useNavigate } from 'react-router-dom';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import { useTypedDispatch } from '@hook/common/useStore';
import Scroll from '@component/common/scroll';

const ConfigurationPage: React.FC<any> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useTypedDispatch();

  return (
    <PageTemplate
      title={'학습설정'}
      mode={'back'}
      handleNavigationClick={() => {
        navigate(IYAGIGO_PATH.STUDIO_HOME_PATH);
      }}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        <Configuration />
      </Scroll>
    </PageTemplate>
  );
};

export default ConfigurationPage;
